<template>
  <div v-if="authenticationService.entities.length > 0">
    <table class="table table-striped is-narrow">
      <thead>
        <tr>
          <th>{{$t('users.activities.activity')}}</th>
          <th>{{$t('facility.inputs.entity')}}</th>
          <th v-if="editable"></th>
        </tr>
      </thead>
      <tbody>
        <tr style="height:63px" v-for="(item, index) in filteredDataset" :key="index">
          <td width="30%" class="align-middle">
            <span>
              {{$t(`activities.${item.id}`, item.name)}}&nbsp;
            </span>
          </td>
          <td :width="tdDynamicSize" class="align-middle">
            <div v-if="!isEditingActivity || editingRow !== index">
              <div v-if="item.entities.length > 0">
                <div v-if="item.entities.length > limitItems">
                  <va-popover
                    v-for="(item, index) in getFirstNItems(item.entities, limitItems)" :key="index"
                    :message="item.description"
                    placement="top">
                    <div class="tag-role">
                      {{item.name}}
                    </div>
                  </va-popover>
                  <span @click="openAllEntities(item)" class="tag-role clickable">
                    {{$t('users.roles.actions.show_more')}} {{item.entities.length - limitItems}}..
                  </span>
                </div>
                <div v-else>
                  <va-popover
                    v-for="(item, index) in item.entities" :key="index"
                    :message="item.description"
                    placement="top">
                  <div class="tag-role">
                    {{item.name}}
                  </div>
                </va-popover>
                </div>
              </div>
              <div v-else>
                <span v-if="isEditingPersonActivity">{{ $t('users.activities.without_entity', {name: item.name.toLowerCase()})}}</span>
                <span v-else>{{ $t('entities.activities.without_entity', {name: item.name.toLowerCase()})}}</span>
              </div>
            </div>
            <div v-if="isEditingActivity && editingRow === index">
              <form class="evollu-form">
                <multiselect
                  :options="entitiesOptions"
                  v-model="editingEntities"
                  track-by="id"
                  label="name"
                  :custom-label="formatedEntityLabel"
                  select-label=""
                  deselect-label="×"
                  :placeholder="'users.activities.entities' | translate"
                  :allow-empty="true"
                  :multiple="true"
                  :searchable="true"
                  :close-on-select="true"
                  :limit="limitItems">
                  <span slot="noResult">{{'patients.noResults'| translate}}</span>
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.name }} {{item.cities && item.cities.length ? '(' + item.cities.join(', ') + ')' : ''}}</span>
                      <i @click="remove(option, remove)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <span class="option__name">
                      {{ props.option.name }}
                      <span v-if="props.option.entities && Array.isArray(props.option.entities)">
                        {{$t('users.roles.custom_clusters_label', {number: props.option.entitiesWithPermissions})}}
                      </span>
                      <span v-else>
                        <span>{{props.option.cities && props.option.cities.length ? '(' + props.option.cities.join(', ') + ')' : ''}}</span>
                      </span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="editingEntities.length" @mousedown.prevent.stop="editingEntities = []"></div>
                  </template>
                </multiselect>
              </form>
            </div>
          </td>
          <td v-if="editable" width="20%" class="align-middle">
            <div class="d-flex justify-content-end">
              <span v-if="!isEditingActivity" @click.prevent="editUserEntityActivity(item, index)">
                <i class="fa fa-pencil clickable"></i>
              </span>
              <va-button
                v-if="isEditingActivity && editingRow === index"
                class="btn-cancel"
                @click.prevent="cancelEdit(item.id, index)">
                {{$t('modals.buttons.cancel')}}
              </va-button>
              &nbsp;
              <va-button
                v-if="isEditingActivity && editingRow === index"
                @click.prevent="saveUserEntityRole(item)">
                {{$t('modals.buttons.save')}}
              </va-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import DynamicSizeMixin from '../../Helpers/DynamicSizeMixin'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: {
    isEditingPersonActivity: {
      type: Boolean,
      required: false,
      default: true
    },
    availableActivities: {
      type: Array,
      required: false,
      default: () => []
    },
    activities: {
      type: Array,
      required: true
    },
    query: {
      type: String,
      required: false,
      default: ''
    },
    limitItems: {
      type: Number,
      required: false,
      default: 3
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    clusters: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    Multiselect
  },
  data () {
    return {
      isEditingActivity: false,
      editingRow: -1,
      editingEntities: [],
      dataset: [],
      showFullEntities: false
    }
  },
  mixins: [
    DynamicSizeMixin,
    MultiselectLabelFormatter
  ],
  mounted () {
    this.generateDataset()
  },
  methods: {
    getNumberEntitiesWithPermissions: function (entitiesIds) {
      return entitiesIds.filter(entityId => {
        return this.usersAuthPermissions.some(p => p.entity_id === entityId)
      }).length
    },
    closeEntitiesByRoleModal: function () {
      this.showFullEntities = false
      this.entitiesForSelectedRole = []
    },
    openAllEntities: function (activity) {
      this.isEditingActivity = false
      this.showFullEntities = true
      this.$emit('show-entities-for-activity-modal', {
        entities: activity.entities,
        activity
      })
    },
    generateDataset: function () {
      this.dataset = []
      this.availableActivities.forEach(activity => {
        let index = this.dataset.findIndex(item => item.id === activity.id)
        if (index === -1) {
          this.dataset.push({
            id: activity.id,
            name: activity.name,
            entities: []
          })
        }
      })
      // Para cada entidade do utilizador para qual está a editar
      this.activities.forEach(userActivity => {
        // Se encontrar um indice de entidade para esse utilizador adiciona as roles dessa entidade
        let index = this.dataset.findIndex(item => item.id === userActivity.activity.id)
        if (index >= 0) {
          this.dataset[index].entities.push({
            ...userActivity.entity
          })
        }
      })
      // Sort dataset
      this.dataset.sort((a, b) => {
        let entityNameA = a.name.toLowerCase()
        let entityNameB = b.name.toLowerCase()

        if (entityNameA < entityNameB) return -1
        if (entityNameA > entityNameB) return 1
        return 0
      })
    },
    editUserEntityActivity: function (userActivity, selectedRow) {
      if (selectedRow !== this.editingRow) {
        this.isEditingActivity = true
        this.editingRow = selectedRow
        this.editingEntities = JSON.parse(JSON.stringify(userActivity.entities))
      } else {
        this.isEditingActivity = !this.isEditingActivity
        this.editingRow = -1
      }
    },
    getFirstNItems: function (arr, n) {
      return arr.slice(0, n)
    },
    saveUserEntityRole: function (activity) {
      let entitiesToSubmit = []
      let clustersSelected = this.editingEntities.filter(item => item.entities && Array.isArray(item.entities))
      if (clustersSelected.length > 0) {
        clustersSelected.forEach(cluster => {
          entitiesToSubmit.push(...cluster.entities.map(e => {
            return e.id
          }))
        })
      }
      let entitiesSelected = this.editingEntities.filter(item => !item.entities)
      if (entitiesSelected.length > 0) {
        entitiesToSubmit.push(...entitiesSelected.map(e => {
          return e.id
        }))
      }
      let form = {
        activity_id: activity.id,
        entities_ids: [...new Set(entitiesToSubmit)]
      }
      this.$emit('update-user-activities', form)
      this.resetFields()
    },
    cancelEdit: function () {
      this.editingRow = -1
      this.isEditingActivity = false
    },
    resetFields: function () {
      this.editingRow = -1
      this.isEditingActivity = false
      this.editingEntities = []
      this.dataset = []
      this.generateDataset()
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    entitiesOptions: function () {
      let multiSelectItems = []
      let clustersWithAccessableEntities = this.clusters.map(cluster => {
        cluster.entitiesWithPermissions = this.usersAuthPermissions.some(p => {
          return p.entity_id === null
        }) ? cluster.entitiesIds.length : this.getNumberEntitiesWithPermissions(cluster.entitiesIds)
        return cluster
      }).filter(cluster => {
        return cluster.entitiesWithPermissions > 0
      })
      if (clustersWithAccessableEntities.length > 0) {
        multiSelectItems.push({ name: this.$t('menu.clusters').toUpperCase(), $isDisabled: true })
        multiSelectItems = multiSelectItems.concat(clustersWithAccessableEntities.map(element => {
          return {
            ...element,
            uid: `c${element.id}`
          }
        }))

        // Add Entities Option
        multiSelectItems.push({ name: this.$t('agenda.screenings.labels.entities').toUpperCase(), $isDisabled: true })
      }

      multiSelectItems.push(...this.authenticationService.entities.map(element => {
        return {
          ...element,
          uid: `e${element.id}`
        }
      }))

      return multiSelectItems
    },
    filteredDataset: function () {
      if (this.query === '') return this.dataset
      return this.dataset.filter(item => {
        return item.name.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
      })
    },
    authenticationService: function () {
      return this.$store.state.services.find(s => s.url === this.$store.state.evollauth_server)
    },
    authPermissions: function () {
      return this.authenticationService.user_permissions
    },
    usersAuthPermissions: function () {
      return this.authPermissions.filter(p => p.info_type === 100)
    },
  },
  watch: {
    activities: {
      handler () {
        this.generateDataset()
      },
      deep: true
    },
    query: debounce(function () {
      this.generateDataset()
    }, 500)
  }
}
</script>

<style lang="scss">
  .tag-role{
    margin-right: 10px;
    margin-bottom: 0.5rem;
    padding: 0.4em 1em;
    background: #29c4a9;
    color: white;
    border-radius: 1em;
    font-weight: 100;
    font-size: 13px;
    white-space: nowrap;
  }

  .action-buttons-wrapper {
      margin-top: 10px;
  }

  .custom__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #29c4a9;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .custom__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: normal;
    width: 22px;
    text-align: center;
    line-height: 22px;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    border-radius: 5px;
  }

  .custom__tag-icon:focus, .custom__tag_removable-icon:hover {
    background: #21ab93;
  }

  .custom__tag-icon:after {
    content: "\D7";
    color: #266d4d;
    font-size: 14px;
  }

  .custom__tag-icon:focus:after, .custom__tag-icon:hover:after {
    color: #fff;
  }

  .without_remove_action{
    padding-right: 10px !important;
  }

  .no-entity-activity {
    text-transform: capitalize;
  }
</style>
